import {
    FormControl,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ListSubheader,
    MenuItem,
    Select,
    Stack, Tooltip,
    Typography
} from "@mui/material";
import _ from 'underscore'
import {allWeapons} from "./WeaponData";
import {ItemPaper} from "./WeaponBuilder";
import RandomiseIcon from '@mui/icons-material/Casino';
import {inputPlaceholder, lowerOffset, randomInt, useIsMobileHook} from "../utils";

export const weaponsByClass = _.groupBy(allWeapons, (weapon) => weapon.type);

export const RandomiseButton = ({label, onClick}) => {
    return <Tooltip title={label} slotProps={lowerOffset}>
        <RandomiseIcon onClick={onClick} sx={{
            transition: 'filter 0.3s ease',
            '&:hover': {
                filter: 'drop-shadow(0px 0px 6px rgb(200 200 200))',
                background: 'none'
            }
        }}/>
    </Tooltip>;
}

function Weapons({selectedWeapon, setSelectedWeapon}) {

    const isMobile = useIsMobileHook()

    const handleWeaponSelection = (event, weapon) => {
        setSelectedWeapon(weapon);
    }

    const mobileSelect = () => {
        return (
            <FormControl>
                <Select
                    labelId="weapon-select-label"
                    id="weapon-select"
                    value={selectedWeapon}
                    onChange={(event) => setSelectedWeapon(event.target.value)}
                    renderValue={(selected) => inputPlaceholder(selected?.name, "View Weapons")}
                    displayEmpty
                >
                    {
                        Object.keys(weaponsByClass).flatMap((type) => [
                            <ListSubheader key={type} sx={{fontWeight: '100', backgroundColor: '#61616121'}}>
                                {type}
                            </ListSubheader>,
                            weaponsByClass[type].map((weapon) =>
                                <MenuItem key={weapon.name} value={weapon}>{weapon.name}</MenuItem>
                            )]
                        )
                    }
                </Select>
            </FormControl>
        )
    }

    return (
        <ItemPaper sx={{height: {xs: 'auto', md: '30vh'}}}>
            <Stack sx={{height: '100%'}}>
                <Stack sx={{width: '100%'}} direction='row' justifyContent='space-between'>
                    <Typography variant='h6'>Weapon</Typography>
                    <RandomiseButton label='Random Weapon' onClick={() => setSelectedWeapon(allWeapons[randomInt(allWeapons.length)])}/>
                </Stack>
                {
                    isMobile ? mobileSelect() :
                        <List dense
                              sx={{
                                  width: '100%',
                                  overflow: 'auto',
                                  '& ul': {padding: 0},
                              }}
                              subheader={<li/>}
                        >
                            {Object.keys(weaponsByClass).map((type) => (
                                <li key={`section-${type}`}>
                                    <ul>
                                        <ListSubheader>{type}</ListSubheader>
                                        {weaponsByClass[type].map((weapon) => (
                                            <ListItemButton
                                                key={`item-${type}-${weapon.name}`}
                                                selected={selectedWeapon === weapon}
                                                onClick={(event) => handleWeaponSelection(event, weapon)}
                                            >
                                                <ListItem>
                                                    <ListItemText primary={weapon.name}/>
                                                </ListItem>
                                            </ListItemButton>
                                        ))}
                                    </ul>
                                </li>
                            ))}
                        </List>
                }
            </Stack>
        </ItemPaper>
    )
}

export default Weapons;
